const defaultClickEvent = {
	event: 'widgetUserEvent',
	element: 'More details button',
	elementCTA: 'Details',
	action: 'clicked',
	result: 'Revealed detail information popup',
	widgetName: 'ws-detailed-pricing',
	widgetId: 'detailed-pricing1',
	widgetState: 'default',
	fieldValue: undefined,
	formId: undefined,
	formEventId: undefined,
	value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
	let trackingObject = {};
	if (typeof window === 'object') {
		trackingObject = window.jQuery(document) || {};
	}

	if (Object.keys(trackingObject).length > 0) {
		trackingObject.trigger('trackEvent', {
			...defaultClickEvent,
			...eventData
		});
	}
}

export function moreDetailsEvent(widgetName, widgetId, elementCTA) {
	const eventData = {
		widgetName,
		widgetId,
		elementCTA
	};
	trackGoogleAnalyticsEvent(eventData);
}

export function closeDetailsEvent(widgetName, widgetId) {
	const eventData = {
		element: 'Close button',
		elementCTA: undefined,
		action: 'clicked',
		result: 'Closed detailed information popup',
		widgetName,
		widgetId
	};
	trackGoogleAnalyticsEvent(eventData);
}

export function priceDetailsScrollEvent(widgetName, widgetId) {
	const eventData = {
		element: 'Price details link',
		elementCTA: 'Pricing Detail',
		result: 'Scrolled to destination',
		widgetName,
		widgetId
	};
	trackGoogleAnalyticsEvent(eventData);
}

export function disclaimerDetailsModalEvents(widgetName, widgetId, modalState) {
	let eventData;
	if (modalState) {
		eventData = {
			element: 'Disclaimer details link',
			elementCTA: undefined,
			result: 'Opened dialog',
			widgetName,
			widgetId
		};
	} else {
		eventData = {
			element: 'Close button',
			elementCTA: undefined,
			result: 'Closed dialog',
			widgetState: 'Disclaimer dialog',
			widgetName,
			widgetId
		};
	}
	trackGoogleAnalyticsEvent(eventData);
}

export function ePriceButtonTrackEvent(
	buttonLabel,
	widgetName,
	widgetId,
	openModal
) {
	const eventData = {
		element: 'Instant ePrice button',
		elementCTA: buttonLabel,
		result: openModal ? 'Opened dialog' : 'ePrice diplayed',
		widgetName,
		widgetId
	};
	trackGoogleAnalyticsEvent(eventData);
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js